import React from "react";

import {
  Datagrid,
  EditButton,
  ShowButton,
  DeleteWithConfirmButton,
  List,
  TextField,
  DateField,
  SelectField,
} from "react-admin";

import { EmptyList } from "../../../common/components";
import { dateOptions } from "../../../utils/options";
import { auctionType } from "../../../utils/options";
const ListAuctions = () => {
  return (
    <List
      hasCreate
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="Заглавие"
          source="title"
          sortable={false}
        />
        <SelectField
          label="Вид"
          source="auction_type"
          choices={auctionType}
          sortable={false}
        />
        <DateField
          label="Дата от"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
          sortable={false}
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListAuctions;
